import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useCustomerPrivileges } from '@pages/customers'
import { useCustomerDetailsApi } from '@pages/customers'
import { useCustomerStore } from '@entities/customer'

import { defineNuxtRouteMiddleware } from '#app'

/**
 * `customers.details` needs view-customers; without it the page is built from `customers.show`
 * (loaded by `customer-show`), as the legacy page did for simple viewers.
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const customerId = to.params.id

  if (typeof customerId !== 'string' || !customerId) return

  const customerStore = useCustomerStore()

  if (customerStore.getDetails?.id !== Number(customerId)) {
    customerStore.resetDetails()
  }

  const { canViewCustomers } = useCustomerPrivileges()

  if (canViewCustomers.value) {
    void useCustomerDetailsApi({ customerId })
  }
})
